import React from 'react';
import SaveButton from '../SaveButton';
import ListingsHeaderV2 from '../../MainListing/ListingsHeaderV2';
import {useThemeColors} from '../../HelperClasses/ThemeContext';
import {TouchableOpacity, View} from 'react-native';
import BackBtnView from '../BackBtnView';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';

const PageHeader = ({
  title,
  close_action,
  save_action,
  save_button_title = 'Save',
  isHideBackButton = false,
}) => {
  const themeColors = useThemeColors();

  return (
    <ListingsHeaderV2
      simple={true}
      titleArea={
        <View style={{flexDirection: 'row', alignItems: 'center'}}>
          {!isHideBackButton && (
            <TouchableOpacity
              style={[tableStyle.backBtnBackViewStyle, {marginRight: 12}]}
              onPress={() => close_action()}>
              <BackBtnView />
            </TouchableOpacity>
          )}
          <p
            className="text-2xl font-medium font-sans"
            style={{color: themeColors.primaryText}}>
            {title}
          </p>
        </View>
      }
      actionControl={
        <SaveButton
          saveBtn={() => save_action()}
          saveBtnTitle={save_button_title}
          showSaveBtn={true}
        />
      }
    />
  );
};

export default PageHeader;
